import Tooltip from "devextreme-react/tooltip";
import { one } from "devextreme/events";
import React, { useEffect, useRef } from "react";

interface IGrantDetailPreAwardTaskTooltipProps {
    taskName: string | null;
    taskStatus: string | null;
    subTaskName: string | null;
    subTaskStatus: string | null;
    commentUser: string | null;
    commentDate: string | null;
    target: string;
}
export default function GrantDetailPreAwardTaskTooltip({ taskName, taskStatus, subTaskName, subTaskStatus, commentUser, commentDate, target }: IGrantDetailPreAwardTaskTooltipProps) {

    const getTooltipContent = () => {

        if (taskName != null) {
            return (
                <div className="phase-comment-popup">
                    <p>Task: {taskName} ({taskStatus})</p>
                    <p>Subtask: {subTaskName} ({subTaskStatus})</p>
                    <p>User: {commentUser}</p>
                    <p>Date: {commentDate}</p>
                </div>
            );
        }
    };

    function normalizeTarget(target: string): string {
        if (target.startsWith("#")) {
            return target;
        }
        return `#${target}`;
    }

    if (taskName == null)
        return null;
    else
        return (
            <Tooltip
                contentRender={getTooltipContent}
                hideEvent={{ name: "mouseleave", delay: 50 }}
                onHiding={(e: any) => {
                    e.cancel = new Promise(cancel => {
                        setTimeout(() => {
                            const popupContainer = e.component.content().parentElement;
                            if (popupContainer != null) {
                                const isHover = popupContainer.parentNode.matches(':hover');
                                if (isHover) {
                                    one(popupContainer, 'mouseleave', () => {
                                        cancel(false);
                                    });
                                } else {
                                    cancel(false);
                                }
                            }
                        }, 50);
                    })
                }}
                showEvent={{ name: "mouseenter", delay: 500 }}
                target={`${normalizeTarget(target)}`}
                width={400}
            ></Tooltip>
        )
}